import React, { useContext, useState } from 'react';
import { Chain, ChainClient, CreateHostNameRequest } from '../../../services/WebApiClient';
import { LoginContext } from '../../EditorCommon/LoginContext';
import { HostNameTable } from './HostNameTable';

export function HostNameAdmin(props: {
    chain: Chain,
    onChange: () => void,
}) {

    const [newHostname, setNewHostname] = useState("");
    const [isWorking, setIsWorking] = useState(false);
    const loginContext = useContext(LoginContext);

    const canCreate = !isWorking && !!newHostname;

    async function createHostName(evt: React.FormEvent) {
        evt.preventDefault();
        if (!canCreate) {
            return;
        }

        setIsWorking(true);
        try {
            const client = new ChainClient(undefined, loginContext.loginService.http);
            await client.createHostName(new CreateHostNameRequest({
                chainId: props.chain.id,
                host: newHostname
            }));
            setNewHostname("");
        }
        catch (ex) {
            window.alert(`Could not set hostname: ${ex}`);
        }
        finally {
            setIsWorking(false);
        }
        props.onChange();
    }


    return (
        <>
            {props.chain.hostNames.length > 0
                ? <HostNameTable hostnames={props.chain.hostNames} onHostnameDeleted={props.onChange} />
                : "No host names"
            }

            <form onSubmit={createHostName}>
                <div className="input-group mb-3" >
                    <input className="form-control" type="text"
                        value={newHostname}
                        placeholder="mychain.example.com"
                        onChange={evt => setNewHostname(evt.target.value)} />
                    <div className="input-group-append">
                        <button className="btn btn-primary"
                            disabled={!canCreate}
                        >
                            Create
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
}
